import { useEffect, useState } from 'react';

import { determinePageType } from './determinePageType';
import type { PageContextType } from './PageContextType';
import { UseCase } from './UseCase';
import { useWindowLocation } from './useWindowLocation';

export const usePageContextType = (useCase: UseCase = UseCase.THINKING_VIEW): PageContextType => {
	const location = useWindowLocation();
	const [pageContextType, setPageContextType] = useState<PageContextType>(
		determinePageType(location, useCase),
	);

	useEffect(() => {
		setPageContextType(determinePageType(location, useCase));
	}, [location, useCase]);

	return pageContextType;
};
